import { useState, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher.jsx';
import { getAssetUrl } from '../utils/storage.js';
import useStore from '../stores/useStore.jsx';
import { InfoDialog } from "@/components/custom/InfoDialog.jsx";
import { Button } from "@/components/ui/button";
import { HelpCircle } from "lucide-react";
import { FloatingButton } from "@/components/custom/FloatingButton.jsx";
import { cn } from '@/lib/utils.ts';

const Help = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [isPulsing, setIsPulsing] = useState(false);
  const setIsDragging = useStore((state) => state.setIsDragging);

  useEffect(() => {
    setIsDragging(isOpen);
  }, [isOpen, setIsDragging]);

  useEffect(() => {
    const hasSeenHelp = localStorage.getItem('hasSeenHelp');
    if (!hasSeenHelp) {
      setIsOpen(true);
    }
  }, []);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    localStorage.setItem('hasSeenHelp', 'true');

    setIsPulsing(true);
    setTimeout(() => setIsPulsing(false), 8000);
  };

  return (
    <>
      {/* Help Button */}
      <FloatingButton
        onClick={openModal}
        className={cn(
          "z-60",
          isPulsing && "pulse"
        )}
      >
        <HelpCircle className="size-6 md:size-10" />
      </FloatingButton>

      <InfoDialog
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title={<span className="flex items-center gap-2">{t('help.title')} 👋</span>}
        variant="light"
        contentClassName="md:p-8"
        footer={
          <Button
            variant="default"
            className="bg-black text-white hover:bg-gray-800"
            onClick={closeModal}>
            {t('buttons.close')}
          </Button>
        }
      >
        <LanguageSwitcher className="absolute top-2 right-12 scale-75 md:scale-100 text-black" />

        <img
          src={getAssetUrl('./images/gg.jpg')}
          alt="grand garage"
          className="w-full h-32 md:h-48 object-cover my-4 rounded-lg"
        />

        <div className="text-sm md:text-lg mt-4">
          <Trans>{t('help.text')}</Trans>
        </div>
      </InfoDialog>
    </>
  );
};

export default Help;
